module.exports = __webpack_public_path__ + "NewReport_Insights_Light.c7ce3054ad3cc2f315be1c5337812364.hashedasset.svg";